import { Info, TrendingDown } from 'lucide-react';
import { Card } from '../ui/Card';

export function GES2026InfoCard() {
  return (
    <Card className="p-4 bg-blue-50 border-blue-200">
      <div className="flex items-start gap-3">
        <Info className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
        <div className="flex-1">
          <h3 className="font-semibold text-blue-900 mb-2 flex items-center gap-2">
            Nouveaux facteurs d'émissions GES 2026
            <TrendingDown className="w-4 h-4 text-blue-600" />
          </h3>
          <p className="text-sm text-blue-800 mb-3">
            Les calculs de ce scénario utilisent les nouveaux facteurs d'émissions GES 2026,
            plus favorables aux énergies renouvelables et à l'électricité décarbonée.
          </p>
          <div className="space-y-2">
            <div className="text-sm">
              <div className="font-semibold text-blue-900">
                Facteur électricité: 65 gCO₂/kWh (vs 79 gCO₂/kWh actuellement)
              </div>
              <div className="text-blue-700">
                Baisse de 18% grâce à la décarbonation progressive du mix électrique français
              </div>
            </div>
            <div className="text-sm">
              <div className="font-semibold text-blue-900">
                Impact sur votre DPE
              </div>
              <div className="text-blue-700">
                Les pompes à chaleur et systèmes électriques performants sont désormais mieux valorisés,
                facilitant l'atteinte des classes énergétiques supérieures.
              </div>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
}
